export default __webpack_public_path__ + "static/media/logo.46d60994.webp";